module.exports = __webpack_public_path__ + "static/media/trainVideo6.4f4a06d9.mp4";